var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input',{staticClass:"input-filter-search",attrs:{"placeholder":"Buscar ...","suffix-icon":"el-icon-search","clearable":true},on:{"input":_vm.onChangeInputSearch},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})
}
var staticRenderFns = []

export { render, staticRenderFns }